import { render, staticRenderFns } from "./BsiContinuousFilingFormDetails.vue?vue&type=template&id=b0bf0868&scoped=true&"
import script from "./BsiContinuousFilingFormDetails.vue?vue&type=script&lang=js&"
export * from "./BsiContinuousFilingFormDetails.vue?vue&type=script&lang=js&"
import style0 from "./BsiContinuousFilingFormDetails.vue?vue&type=style&index=0&id=b0bf0868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bf0868",
  null
  
)

export default component.exports